<div class="timeline-page p-3">
  <div class="timeline-toolbar d-flex align-items-center gap-2">
    <div class="timeline-title fw-bold">{{ 'TIMELINE.TITLE' | translate }}</div>

    <ng-select
      class="device-filter"
      name="timelineDevices"
      [items]="deviceOptions"
      bindLabel="serialNumber"
      bindValue="id"
      [multiple]="true"
      [hideSelected]="false"
      [closeOnSelect]="false"
      [clearable]="true"
      placeholder="{{ 'TIMELINE.DEVICES' | translate }}"
      [(ngModel)]="selectedDeviceIds"
      (change)="onDeviceChange()">
      <ng-template ng-multi-label-tmp let-items="items">
        <span class="device-select-label">{{ getSelectedDeviceLabel(items) }}</span>
        <span class="device-select-count" *ngIf="items.length > 0">{{ items.length }}</span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$">
        <div class="device-option d-flex align-items-start gap-2">
          <span class="device-option-checkbox" [class.checked]="item$.selected"></span>
          <span class="device-option-name fw-bold">{{ item.serialNumber }}</span>
        </div>
      </ng-template>
    </ng-select>

    <div class="toolbar-actions ms-auto d-flex align-items-center justify-content-end gap-2">
      <app-date-picker
        [(value)]="selectedStartDate"
        (valueChange)="onStartDateChange($event)">
      </app-date-picker>

      <button class="icon-button" type="button" (click)="goToPreviousPeriod()">‹</button>
      <button class="today-button" type="button" (click)="goToToday()">{{ 'TIMELINE.TODAY' | translate }}</button>
      <button class="icon-button" type="button" (click)="goToNextPeriod()">›</button>

      <ng-select
        class="view-select"
        [items]="viewOptions"
        bindLabel="label"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        [(ngModel)]="selectedView"
        (change)="onViewChange()">
      </ng-select>
    </div>
  </div>

  <div class="timeline-grid-wrapper">
    <div class="timeline-grid" [style.--days]="days.length">
      <div class="corner-cell"></div>

      <div
        class="day-header"
        *ngFor="let day of days"
        [class.today]="day.isToday"
        [class.weekend]="day.isWeekend"
      >
        <div class="day-name">{{ day.dayName }}</div>
        <div class="day-number">{{ day.dayNumber }}</div>
      </div>

      <ng-container *ngFor="let device of filteredDevices">
        <div class="device-cell">
          <svg-icon [src]="'./icon/device.svg'"></svg-icon>
          <span class="mt-2">{{ device.deviceName || 'Device name' }}</span>
        </div>

        <div
          class="record-cell"
          *ngFor="let day of days"
          [class.today]="day.isToday"
          [class.weekend]="day.isWeekend"
        >
          <div
            class="record-badge"
            *ngIf="hasRecords(device, day)"
            [class.red-alert]="getAlertCount(device, day) > 0"
          >
            <svg-icon [src]="'./icon/micro-records-white.svg'"></svg-icon>
            <span>x{{ getCount(device, day) }}</span>
          </div>

          <div class="record-tooltip" *ngIf="hasRecords(device, day)">
            <div *ngIf="getAlertCount(device, day) > 0" class="tooltip-line red-dot">
              {{ getAlertCount(device, day) }} {{ 'TIMELINE.RECORDS' | translate }}
            </div>
            <div class="tooltip-line normal-dot" *ngIf="getNormalCount(device, day) > 0">
              {{ getNormalCount(device, day) }} {{ 'TIMELINE.RECORDS' | translate }}
            </div>
            <div class="tooltip-line normal-dot" *ngIf="getAlertCount(device, day) === 0 && getNormalCount(device, day) === 0">
              {{ getCount(device, day) }} {{ 'TIMELINE.RECORDS' | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="empty-state" *ngIf="!isLoading && filteredDevices.length === 0">
      {{ 'TIMELINE.NO_RECORDS' | translate }}
    </div>

    <div class="loading-state" *ngIf="isLoading">
      {{ 'TIMELINE.LOADING' | translate }}
    </div>
  </div>
</div>
